export const demoValidURLs = [    
    "/webdemo/principal/consola-componentes",
    "/webdemo/principal/arbol-tarifario",
    "/webdemo/principal/opcion-tarifaria",
    "/webdemo/principal/reliquidaciones",
    "/webdemo/principal/publicar-tarifas",
    "/webdemo/principal/alumbrado-publico",
    "/webdemo/principal/validacion-archivos",
    "/webdemo/principal/validacion-parametros",
    "/webdemo/principal/mercados",    
    "/webdemo/principal/contratos-compra",
    "/webdemo/principal/contratos-venta",
    "/webdemo/principal/actores-financieros",
    "/webdemo/principal/balance-energetico", 
    "/webdemo/principal/informe-comercializacion",
    "/webdemo/principal/reportes-sui",
    "/webdemo/principal/liquidacion-str",
    "/webdemo/autogeneradores/usuarios",
    "/webdemo/autogeneradores/parametrizacion-precios-pactados",
    "/webdemo/autogeneradores/parametrizacion-conceptos",
    "/webdemo/autogeneradores/parametrizacion-ciclos",  
    "/webdemo/autogeneradores/parametrizacion-causas-no-lectura",  
    "/webdemo/autogeneradores/control-archivos",
    "/webdemo/autogeneradores/consumos-cliente",
    "/webdemo/autogeneradores/liquidacion-consumos",
    "/webdemo/autogeneradores/reporte-usuario",
    "/webdemo/autogeneradores/exportar-liquidacion",
    "/webdemo/autogeneradores/informe-facturacion",
    "/webdemo/autogeneradores/tendencia-facturacion",
    "/webdemo/autogeneradores/consultas/panel-principal",
    "/webdemo/autogeneradores/consultas/descargar-reporte",
    "/webdemo/autogeneradores/consultas/estado-pago-excedentes",
    "/webdemo/autogeneradores/consultas/comportamiento-estimado",
    "/webdemo/facturador/parametrizacion-ciclos",
    "/webdemo/facturador/parametrizacion-mensual",
    "/webdemo/facturador/parametrizacion-anual",
    "/webdemo/facturador/parametrizacion-cuentas-bancarias",
    "/webdemo/facturador/parametrizacion-operadores-de-red",
    "/webdemo/facturador/parametrizacion-conceptos",
    "/webdemo/facturador/parametrizacion-alumbrado-publico",
    "/webdemo/facturador/parametrizacion-impuesto-seguridad",
    "/webdemo/facturador/control-principal-clientes",
    "/webdemo/facturador/cargar-consumos-ciclo",    
    "/webdemo/facturador/informacion-consumos-cliente",
    "/webdemo/facturador/liquidar-consumos",   
    "/webdemo/facturador/liquidar-alumbrado",
    "/webdemo/facturador/liquidar-impuesto-seguridad",
    "/webdemo/facturador/cargar-otros-conceptos",
    "/webdemo/facturador/conceptos-por-cliente",
    "/webdemo/facturador/generar-facturas",
    "/webdemo/facturador/reportes-internos",
    "/webdemo/facturador/reportes-sui",
    "/login",    
]